<template>
  <!-- 退件单 -->
  <div>
    <el-card class="mb5">
      <el-tabs v-model="activeName" style="margin-top: -10px" @tab-click="handleClick">
        <el-tab-pane name="0">
          <span slot="label">
            {{ $t('trajectory.newOrderReturn') }}
          </span>
        </el-tab-pane>
        <el-tab-pane name="1"><span slot="label">
          {{ $t('trajectory.originalOrderReturnD2D') }}
        </span>
        </el-tab-pane>
      </el-tabs>
      <div style="margin-bottom: 15px">
        <!-- 新增：扫描类型选择 + 输入框 -->
        <div style="display: flex; align-items: center; gap: 10px">
          <el-select
            v-model="scanType"
            size="small"
            style="width: 150px"
            @change="handleScanTypeChange"
          >
            <el-option :label="$t('orderCenterCont.anjunWaybillNumber')" value="waybillNumber" />
            <el-option :label="$t('collectionCenter.ScanNumber')" value="scanOrderNumber" />
            <el-option :label="$t('home.nfeInvoiceKey')" value="nfeKey" />
          </el-select>

          <el-input
            v-model="returnNoteVal"
            :placeholder="$t('collectionCenter.scanOrInputParcelNumber')"
            clearable
            size="small"
            style="width: 300px"
            @keyup.enter.native.stop="(e) => addReturnData(e)"
          />
        </div>
      </div>
      <div style="margin-bottom: 20px">
        <span style="font-weight: bold; font-size: 14px; color: #606266; margin-right: 20px">
          {{ $t('collectionCenter.scanned') }}：<span style="color: #00a551">{{
            tableData.length
          }}</span>
        </span>
        <!--  发起退件  -->
        <el-button size="small" type="primary" @click="toReturn">{{ $t('collectionCenter.InitiateRejection') }}
        </el-button>
      </div>
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black', 'text-align': 'center' }"
        :max-height="600"
        border
        style="width: 100%"
      >
        <!-- 序号 -->
        <el-table-column
          :label="$t('collectionCenter.ind')" align="center" prop="ind"
          width="60"
        />
        <!-- 运单号 -->
        <el-table-column
          :label="$t('collectionCenter.waybillNumber')"
          align="center"
          prop="waybillNumber"
        />
        <!-- 扫描单号 -->
        <el-table-column
          :label="$t('collectionCenter.scanInfo')"
          align="center"
          prop="scanNumber"
        />
        <!-- 扫描人 -->
        <el-table-column :label="$t('collectionCenter.scanner')" align="center" prop="person" />
        <!-- 扫描时间 -->
        <el-table-column :label="$t('collectionCenter.scanTime')" align="center" prop="scanTime" />
        <el-table-column :label="$t('collectionCenter.operation')" align="center">
          <template slot-scope="scope">
            <el-popconfirm :title="$t('collectionCenter.deleteSure')" @confirm="del(scope.$index)"><!-- 确定删除吗？ -->
              <div slot="reference" style="cursor: pointer; color: red">
                {{ $t('collectionCenter.Delete') }}
              </div>
              <!-- 删除 -->
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      :before-close="handleClose"
      :close-on-click-modal="false"
      :show-close="false"
      :title="$t('collectionCenter.tips')"
      :visible.sync="dialogVisible"
      class="returnDialogClass"
      width="50%"
    >
      <div>
        <span>{{ $t('collectionCenter.initiateReturnTotal') }}：{{ sumbitMsg.reverseTotal }}</span>
        <div style="margin-top: 20px; margin-bottom: 20px">
          <span style="display: inline-block; width: 50%">{{ $t('collectionCenter.orderSuccessful') }}：{{ sumbitMsg.reverseSuccess }}</span>
          <span style="display: inline-block; width: 50%">{{ $t('collectionCenter.orderFailure') }}：{{
            sumbitMsg.reverseFailList ? sumbitMsg.reverseFailList.length : 0
          }}</span>
        </div>
        <div v-if="sumbitMsg.reverseFailList && sumbitMsg.reverseFailList.length > 0">
          <span>{{ $t('collectionCenter.orderFailedOrder') }}：</span>
          <el-table :data="sumbitMsg.reverseFailList" :max-height="500" :show-header="false">
            <el-table-column :label="$t('collectionCenter.ind')" prop="ind" width="60" />
            <el-table-column :label="$t('collectionCenter.order')" prop="waybillNumber" />
            <el-table-column :label="$t('collectionCenter.reason')" prop="failReason" />
          </el-table>
        </div>
      </div>
      <span slot="footer">
        <el-button size="small" type="primary" @click="handleClose">{{
          $t('collectionCenter.close')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  newReverseScan,
  newReverseScanD2D,
  reverseSumbit,
  reverseSumbitD2D
} from '@/api/automaticSorting';
import dayjs from 'dayjs';

export default {
  name: 'ReturnNote',
  data() {
    return {
      scanType: 'waybillNumber', // 默认：安骏运单号
      activeName: '0',
      returnNoteVal: '',
      tableData: [],
      dialogVisible: false,
      sumbitMsg: {}
    };
  },
  methods: {
    // Tab切换事件
    handleClick(val) {
      console.log(val.name, 'handleClick', this.activeName);
      // 切换tab时清空表格数据，避免不同tab间的数据混淆
      this.tableData = [];
      // 同时清空输入框
      this.returnNoteVal = '';
      // 【新增】切换tab时，重置扫描类型为默认选项（安骏运单号）
      this.scanType = 'waybillNumber';
    },

    // 切换扫描类型时清空输入框
    handleScanTypeChange() {
      this.returnNoteVal = '';
    },

    // 添加退件数据（扫描或输入后回车触发）
    addReturnData(e) {
      e.preventDefault();
      e.stopPropagation();
      // 如果输入框为空，直接返回
      if (!this.returnNoteVal) return;

      // 根据扫描类型构建请求参数
      const scanParams = {
        waybillNumber: '', // 运单号
        scanOrderNumber: '', // 扫描单号
        invoiceSecretKey: '' // NFE发票秘钥
      };

      // 根据选择的扫描类型设置对应的参数
      switch (this.scanType) {
        case 'waybillNumber':
          scanParams.waybillNumber = this.returnNoteVal;
          break;
        case 'scanOrderNumber':
          scanParams.scanOrderNumber = this.returnNoteVal;
          break;
        case 'nfeKey':
          scanParams.invoiceSecretKey = this.returnNoteVal;
          break;
        default:
          break;
      }

      // 判断是普通退件还是D2D退件
      if (this.activeName === '0') {
        // 普通退件扫描
        newReverseScan(scanParams)
          .then((res) => {
            if (res.code === 200) {
              // 判断重复：根据扫描类型判断对应的字段
              let isAdd = false;
              if (this.scanType === 'waybillNumber') {
                // 如果是运单号，判断运单号是否重复
                isAdd = this.tableData.some((el) => {
                  return el.waybillNumber === this.returnNoteVal;
                });
              } else {
                // 如果是扫描单号或NFE密钥，判断扫描单号是否重复
                isAdd = this.tableData.some((el) => {
                  return el.scanNumber === this.returnNoteVal;
                });
              }

              // 如果重复，提示用户
              if (isAdd) {
                this.$message({
                  message: this.$t('collectionCenter.repeatDataTips'),
                  type: 'warning'
                });
                return;
              }

              // 操作成功提示
              this.$message.success(this.$t('basicData.TheOperationSucceeded'));

              // 提取返回数据中的运单号（根据接口实际返回调整）
              const waybillNumber = res.data.forwardWaybillNumber || res.data.waybillNumber || '';
              const scanInfo = this.returnNoteVal; // 展示实际扫描的条码信息

              // 添加到表格中
              this.tableData.push({
                ind: this.tableData.length + 1,
                waybillNumber: waybillNumber,
                scanNumber: scanInfo, // 统一使用scanNumber字段名
                person: this.$store.state.user.realName,
                scanTime: dayjs().format('YYYY-MM-DD HH:mm:ss')
              });
              // 清空输入框
              this.returnNoteVal = '';
            }
          })
          .catch((error) => {
            console.error('扫描失败:', error);
          });
      } else {
        // D2D退件扫描
        newReverseScanD2D(scanParams)
          .then((res) => {
            if (res.code === 200) {
              // 判断重复：根据扫描类型判断对应的字段
              let isAdd = false;
              if (this.scanType === 'waybillNumber') {
                // 如果是运单号，判断运单号是否重复
                isAdd = this.tableData.some((el) => {
                  return el.waybillNumber === this.returnNoteVal;
                });
              } else {
                // 如果是扫描单号或NFE密钥，判断扫描单号是否重复
                isAdd = this.tableData.some((el) => {
                  return el.scanNumber === this.returnNoteVal;
                });
              }

              // 如果重复，提示用户
              if (isAdd) {
                this.$message({
                  message: this.$t('collectionCenter.repeatDataTips'),
                  type: 'warning'
                });
                return;
              }

              // 操作成功提示
              this.$message.success(this.$t('basicData.TheOperationSucceeded'));

              // 提取返回数据中的运单号
              const waybillNumber = res.data.waybillNumber || res.data.forwardWaybillNumber || '';
              const scanInfo = this.returnNoteVal;

              // 添加到表格中
              this.tableData.push({
                ind: this.tableData.length + 1,
                waybillNumber: waybillNumber,
                scanNumber: scanInfo, // 统一使用scanNumber字段名
                person: this.$store.state.user.realName,
                scanTime: dayjs().format('YYYY-MM-DD HH:mm:ss')
              });
              // 清空输入框
              this.returnNoteVal = '';
            }
          })
          .catch((error) => {
            console.error('扫描失败:', error);
          });
      }
    },

    // 删除表格中的某一行数据
    del(ind) {
      this.tableData.splice(ind, 1);
      // 重新排序序号，保证序号连续
      this.tableData.forEach((item, index) => {
        item.ind = index + 1;
      });
    },

    // 发起退件操作
    toReturn() {
      // 如果没有数据，提示用户
      if (this.tableData.length <= 0) {
        this.$message.warning(this.$t('GlobalSetObj.notDataUpload'));
        return;
      }

      // 显示加载动画
      const loading = this.$loading({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: 'loading...',
        background: 'rgba(250, 250, 250, 0.6)'
      });

      // 构建提交参数
      const form = {
        waybillNumbers: this.tableData.map((arr) => arr.waybillNumber)
      };

      // 判断是普通退件还是D2D退件
      if (this.activeName === '0') {
        // 普通退件提交
        reverseSumbit(form)
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
              this.sumbitMsg = res.data;
              // 处理失败列表，添加序号
              this.sumbitMsg.reverseFailList = (res.data.reverseFailList || []).map((arr, ind) => {
                return {
                  ind: ind + 1,
                  waybillNumber: arr.waybillNumber,
                  failReason: arr.failReason
                };
              });
              this.dialogVisible = true;
              // 清空表格数据
              this.tableData = [];
            }
          })
          .finally(() => {
            loading.close();
          });
      } else {
        // D2D退件提交
        reverseSumbitD2D(form)
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
              this.sumbitMsg = res.data;
              // 处理失败列表，添加序号（添加空数组判断，避免报错）
              this.sumbitMsg.reverseFailList = (res.data.reverseFailList || []).map((arr, ind) => {
                return {
                  ind: ind + 1,
                  waybillNumber: arr.waybillNumber,
                  failReason: arr.failReason
                };
              });
              this.dialogVisible = true;
              // 清空表格数据
              this.tableData = [];
            }
          })
          .finally(() => {
            loading.close();
          });
      }
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.sumbitMsg = {};
    }
  }
};
</script>

<style lang="scss" scoped>
.returnDialogClass ::v-deep .el-dialog__footer {
  text-align: center;
}

.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
